import { makeStyles } from 'tss-react/mui';

const useStylesDraggableItem: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  draggableItem: {
    cursor: 'grab',
  },
  draggableItemDisabled: {
    cursor: 'default',
  },
  draggableItemDragging: {
    opacity: 0,
    cursor: 'grabbing',
  },
  draggableItemHovered: {
    border: `1px solid ${theme.palette.common.white}`,
    borderTop: `2px solid ${theme.palette.secondary.main}`,
  },
  draggableItemHoveredInverted: {
    border: `1px solid ${theme.palette.common.white}`,
    borderBottom: `2px solid ${theme.palette.secondary.main}`,
  },
}));

export default useStylesDraggableItem;
